var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00195 1.39289C2.99475 0.615515 3.62109 -0.0047711 4.40746 2.76564e-05L13.3369 0.18507L13.3467 0.185159C14.147 0.192395 14.806 0.843554 14.8134 1.63414L15 10.4646C15.0048 11.2414 14.377 11.8602 13.5901 11.8531C12.7897 11.8459 12.1307 11.1947 12.1233 10.4042L12.1232 10.3917L11.9112 5.09082L2.47007 14.4178C1.92663 14.9547 1.01604 14.9618 0.436024 14.3888C-0.143974 13.8158 -0.136798 12.9162 0.406621 12.3794L9.84742 3.0527L4.48141 2.84198L4.46867 2.84187C3.66834 2.83463 3.00927 2.18348 3.00195 1.39289Z",
    fill: "#E44829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowRed);
export default __webpack_public_path__ + "static/media/up-arrow-red.85f1b2f5bce2cbaf762b2f2bf78b28b7.svg";
export { ForwardRef as ReactComponent };